import React, { Component } from 'react'
import { Modal } from 'hljd'
import { toJS } from 'mobx'
import store from './store'

const warning = Modal.warning

class CPTAdvertiseModal extends Component {
  confirmModal(item, i) {
    warning({
      title: '你购买的固定展示位广告将上线了，赶紧去设置需要推广的套餐吧',
      content: (
        <p>
          广告开始时间：{item.scheduleBegin
            ? item.scheduleBegin.split(' ')[0]
            : ''}
          <br />到期未设置将影响广告正常展示
        </p>
      ),
      zIndex: 9999,
      okText: '去设置',
      maskClosable: true,
      onOk: () => {
        window.location.href = `#/localMerchant/marketingCenter/paymentDetail?id=${
          item.bdContractAd.bdContractId
        }`
      },
      onCancel: () => {
        if (!toJS(store.checkList)[i + 1]) {
          return false
        } else {
          this.confirmModal(toJS(store.checkList)[i + 1], i + 1)
        }
      }
    })
  }
  async componentDidMount() {
    await store.init()
    if (toJS(store.checkList).length != 0) {
      this.confirmModal(toJS(store.checkList)[0], 0)
    }
  }
  render() {
    return null
  }
}

export default CPTAdvertiseModal
